const getTasksProgress = (data: any[]) => {
  let totalTasks = 0;
  let finishedTasks = 0;

  data.forEach((taskGroup: any) => {
    taskGroup.tasks.forEach((task: any) => {
      totalTasks++;
      if (task.finished) {
        finishedTasks++;
      }
    });
  });

  return { total: totalTasks, finished: finishedTasks };
};

export default getTasksProgress;
